// extracted by mini-css-extract-plugin
export var accent = "Accent-module--accent--6b219";
export var center = "Accent-module--center--aec4c";
export var large = "Accent-module--large--2fce7";
export var medium = "Accent-module--medium--a8faf";
export var right = "Accent-module--right--603d2";
export var small = "Accent-module--small--78b88";